import Flex from '@deprecated-ui/common/Flex';
import Text from '@deprecated-ui/common/Text';
import Input from '@deprecated-ui/common/Input';
import CheckboxAntd from '@deprecated-ui/common/Checkbox';
import color from '@deprecated-ui/_style/color';
import { Mentions } from 'antd';
import styled, { css } from 'styled-components';
import { COMPOSE_MODE } from './constants';
import {
  ComponentComposeBoxProps,
  ComponentComposeContentProps,
  ComposePostContentProps,
  ImageListContainerProps,
  TextareaAttributeProps,
} from './types';

const { TextArea } = Input;
const { Option: MentionOption } = Mentions;

// Compose box components
const ComposeBox = styled.div<ComponentComposeBoxProps>`
  border: 1px solid ${color.gainsboro};
  transition: height 0.2s ease;
  background: ${color.light};
  border-radius: 3px;

  .show-drag-area {
    border-style: dashed;
    border-width: 2px;
    border-color: ${color.primary};
  }

  ${({ noBorder }) =>
    noBorder &&
    css`
      border: none;
      padding: 0px;
    `}
`;

const ComposeContent = styled.div<ComponentComposeContentProps>`
  width: 100%;
  display: none;
  margin-top: 24px;

  ${({ isExpand }) =>
    isExpand &&
    css`
      display: block;
    `}
`;

const PlaceHolder = styled(Text)`
  font-size: 15px;
  line-height: 50px;
  padding-left: 20px;
  color: ${color.midgray};
  width: 100%;
`;

const Textarea = styled(TextArea).attrs((props: TextareaAttributeProps) => ({
  placeholder: props.placeholder || 'Write here...',
  autoSize: props.autoSize || { minRows: 3 },
}))`
  border: none !important;
  box-shadow: none !important;
  margin-bottom: 12px;
`;

const TextareaMentions = styled(Mentions).attrs(
  (props: TextareaAttributeProps) => ({
    placeholder: props.placeholder || 'Write here...',
    autoSize: props.autoSize || { minRows: 3 },
  }),
)`
  border: none !important;
  box-shadow: none !important;
  font-family: 'ProximaNovaRg';
  margin-bottom: 12px;
  resize: none;
  width: 100%;

  textarea {
    padding: 0;
  }

  :focus {
    outline: none;
  }
`;

const ImageListContainer = styled(Flex)<ImageListContainerProps>`
  overflow: scroll;
  height: ${({ hasImage }) => (hasImage ? 'auto' : '0px')};
`;

const ComposeCommentSetting = styled(Flex).attrs({
  align: 'center',
})`
  border: 1px solid ${color.downgray};
  border-radius: 11.5px;
  width: max-content;
  cursor: pointer;
  padding: 0 6px;
  height: 23px;
`;

const CommentSettingContainer = styled.div`
  padding: 16px;
  border: 1px solid ${color.downgray};
  border-radius: 3px;
  width: 280px;
`;

const Checkbox = styled(CheckboxAntd)`
  .ant-checkbox-inner {
    border-radius: 100% !important;
  }
  .ant-checkbox-checked .ant-checkbox-inner {
    background: ${color.primary};
    border-color: ${color.primary}!important;
  }
`;

const ComposePostContent = styled.div<ComposePostContentProps>`
  padding: 0 20px;
  ${({ mode }) =>
    mode !== COMPOSE_MODE.COMPOSE &&
    css`
      max-height: 340px;
      overflow-y: auto;
    `}
  ${({ mode }) =>
    mode === COMPOSE_MODE.REPOST &&
    css`
      padding-bottom: 20px;
    `}
`;

const MentionSuggestionResult = styled.div`
  > div {
    .ant-mentions-dropdown-menu-item {
      border-bottom: 1px solid #f5f6f5;
      height: 40px;

      & > div {
        height: -webkit-fill-available;
      }
    }
    .ant-mentions-dropdown-menu-item-active {
      p {
        font-family: var(--font-bold) !important;
      }
    }
    .ant-mentions-dropdown-menu-item-disabled {
      display: none;
    }
  }
`;

export {
  ComposeBox,
  ComposeContent,
  PlaceHolder,
  Textarea,
  TextareaMentions,
  MentionOption,
  ImageListContainer,
  ComposeCommentSetting,
  CommentSettingContainer,
  Checkbox,
  ComposePostContent,
  MentionSuggestionResult,
};
